"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OccupationRequest = void 0;
var OccupationRequest = /** @class */ (function () {
    function OccupationRequest() {
    }
    return OccupationRequest;
}());
exports.OccupationRequest = OccupationRequest;
;
//# sourceMappingURL=occupation.request.js.map